(function() {
	'use strict';
	angular.module('app.leanProjects')
		.service('viewTasksService', viewTasksService);
	
	viewTasksService.$inject = ['$http', 'URLS', 'leanFilterService'];
	function viewTasksService($http, URLS, leanFilterService) {
		return {
			getData: getData
		};
		
		function getData() {
			var pageUrl = buildUrl();
			return $http.get(URLS.host + pageUrl)
				.then(getDataComplete)
				.catch(getDataFailed);
			
			function getDataComplete(response) {
				return response.data;
			}
			
			function getDataFailed(error) {
				return [];
			}
		}
		
		function buildUrl() {
			var factories = leanFilterService.getFactoryList();
			var url = URLS.prefix + String.format(URLS.viewTasks, factories);
			url = addFilterQueryParams(url);
			return url;
		}
		
		function addFilterQueryParams(url) {
			var filterQueryParam = leanFilterService.getQueryParam();
			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			return parts[0] + qParams;
		}
	}
})();